export default {
    inserted(el) {
        const input = el.getElementsByTagName('input')[0]
        const fileHolder = el.getElementsByClassName('file-name-holder')[0]
        input.addEventListener('change', (event) => {
            if (event.target.files.length) {
                el.classList.add('filled')
                fileHolder.innerHTML = event.target.files[0].name
            }
        })
    },
}
